import { Button, Grid, Paper, makeStyles } from "@material-ui/core"
import React, { useMemo, useState} from "react"
import { ChartOptions } from "../../../utils/chartOptions";
import { useDialog } from "../../../hooks/useDialog";
import { Dialog } from "../../Dialog/Dialog";
import { AddChartData } from "../../TypeChart/AddChartData";
import { ChartCustom } from "./ChartCustom";
import { ChartScroll } from "./ChartScroll";
import {
    DataGrid,
} from "@material-ui/data-grid";
import { ExcelExportChart } from "./ExcelExportChart";

const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: 'left',
      color: 'black',
      fontSize: '16px',
      fontWeight: 600,
      boxShadow: '0px 0px 10px 6px rgba(0, 0, 0, .1)',
    },
    title: {
        padding: theme.spacing(2),
        textAlign: 'left',
        color: 'black',
        fontSize: '28px',
        fontWeight: 800,
        boxShadow: '0px 0px 10px 6px rgba(0, 0, 0, .1)',
    },
    button: {
        marginBottom: '30px'
    },
    buttonExport: {
        marginBottom: '10px'
    }
  }));

const getRows = (data, nameLine) => {
        return data.map((dot, index) => 
           ({
                id: index + 1,
                ox: dot.name,
                oy: dot[nameLine]
            })
        ) 
    }

export const ChartModule = ({
    initialValue,
    makeLine,
    data,
    line,
    setMakeLine,
    setData,
    setLine,
    label,
    hendleMutateData,
    handleCloseDataDialog,
    openDataDialog,
    dataTable,
    nameLine,
    setDataTable,
    setFieldValue,
    variable,
    value,
}) => {

    const classes = useStyles()
    const addDialog = useDialog();
    const customDialog = useDialog()

    const [rowsTable, setRowsTable] = useState(getRows(dataTable, nameLine))

    const columns = [
        { field: 'id', headerName: 'ID', width: 90 },
        { field: 'ox', headerName: `${initialValue.OX}`,  editable: true, width: 140 },
        { field: 'oy', headerName: `${initialValue.OY}`,  editable: true, width: 140 },
      ];
    
    useMemo(() => {
        setRowsTable(getRows(dataTable, nameLine))
    },[dataTable, nameLine])

    const handleRowChange = (params) => {
        setRowsTable( prev => {
            return prev.map((stroke, index) => {
                if (params.id === index + 1) {
                    return {
                        ...stroke,
                        [params.field]: Number(params.value),
                    }
                }
                return stroke
            })
        })
    }

    const handleSaveDataTable = () => {
        const newTable = rowsTable.map((dot) => { 
            delete dot.id
            return dot
          })
        setDataTable([])
        setData( prev => {
            return prev.map((dot, index) => {
                if (dot.name === newTable[index].ox) {
                    return {
                        ...dot,
                        [nameLine]: newTable[index].oy
                    }
                }
                return dot
            })
        })
    }

    return(
        <div className={classes.root}>
            <Grid 
                container
                spacing={3}
                direction={"row"}
            >
                <Grid item xs={12}>
                    <Paper className={classes.title}>
                        {label}
                    </Paper>
                </Grid>
                <Grid item xs={8}>
                    <Paper className={classes.paper}>
                        {ChartOptions(initialValue, data, line, label, setFieldValue, variable, value)}
                    </Paper>
                </Grid>
                <Grid item xs={4}>
                    <Paper className={classes.paper} style={{height: '630px'}}>
                        <Button
                            className={classes.button}
                            onClick={() => {customDialog.handleOpen()}}
                            color="primary"
                            variant="outlined"
                        >
                            Загрузить данные
                        </Button>
                        {line?.length === 0 ?
                            <h1>
                                Добавьте данные
                            </h1>   
                            :
                            <ChartScroll 
                                line={line}
                                setLine={setLine}
                                hendleMutateData={hendleMutateData}
                            />
                        }
                        
                    </Paper>
                </Grid>
            </Grid>
            <Dialog
                 open={addDialog.open}
                 handleClose={() => {
                     addDialog.handleClose();
                 }}
                 maxWidth={"md"} 
                 fullWidth={true}
            >
                <AddChartData 
                    setData={setData}
                    handleClose={addDialog.handleClose}
                    setLine={setLine} 
                    makeLine={makeLine}
                    setMakeLine={setMakeLine}
                    line={line}
                />
            </Dialog>
            <Dialog
                 open={customDialog.open}
                 handleClose={() => {
                    customDialog.handleClose();
                 }}
                 actions={<Button onClick={() => {customDialog.handleClose(); addDialog.handleOpen()}}>Сохранить</Button>}
                 maxWidth={"md"}  
                 fullWidth={true}
            >
                <ChartCustom 
                    makeLine={makeLine} 
                    setMakeLine={setMakeLine}
                    line={line}
                />
            </Dialog>
            <Dialog
                open={openDataDialog}
                handleClose={() => {
                    handleCloseDataDialog()
                 }}
                title={nameLine}
                actions={<Button onClick={() => { handleCloseDataDialog(); handleSaveDataTable()}}>Сохранить</Button>}
                maxWidth={"sm"} 
                fullWidth={true}
            >   
                <div style={{ height: 600,  padding: '40px' }}>
                        <Button
                            className={classes.buttonExport}
                            color="primary"
                            variant="outlined"
                        >
                            <ExcelExportChart
                                rows={rowsTable}
                                title={nameLine}
                            />
                        </Button>
                        <DataGrid
                            rows={rowsTable}
                            columns={columns}
                            pageSize={50}
                            rowsPerPageOptions={[50]}
                            onCellEditCommit={handleRowChange}
                            disableSelectionOnClick
                            fullWidth
                    />
                </div>
            </Dialog>
        </div>
    )
}